import { Flex, Image, Text } from '@chakra-ui/react';
import React, { memo } from 'react';
// import { ResourceLabelContentArg } from '@fullcalendar/resource-common';

import FallbackAvatar from 'components/FallbackAvatar';

interface IResourceLabelContentProps {
  arg: any;
}

const ResourceLabelContent: React.FC<IResourceLabelContentProps> = ({ arg }) => {
  return (
    <Flex alignItems="center">
      <Image
        fallback={<FallbackAvatar name={arg.fieldValue} boxSize="32px" />}
        boxSize="32px"
        objectFit="cover"
        borderRadius="base"
        src={arg.resource._resource.extendedProps?.employee_image}
        alt={arg.fieldValue}
      />
      <Text ml="2">{arg.fieldValue}</Text>
    </Flex>
  );
};

export default memo(ResourceLabelContent);
